module.exports = __webpack_public_path__ + "img/08.437c8c4d.jpg";